import _Object$assign from "babel-runtime/core-js/object/assign";
var findIndex = function findIndex(field) {
  var childrenArr = this.$children,
      index = "";
  childrenArr.map(function (v1, i) {
    _.each(v1.$refs, function (v2, key) {
      if (key == field) {
        index = i;
        return false;
      }
    });
  });
  return index;
};
export default {
  name: "kui-form",
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    form: function form(opts) {
      if (_.isString(opts)) {
        if ((arguments.length <= 1 ? 0 : arguments.length - 1) > 1) {
          return this[opts].call(this, arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
        } else {
          return this[opts].call(this, arguments.length <= 1 ? undefined : arguments[1]);
        }
      } else {
        _.assign(this.options, opts);
      }
    },
    validate: function validate() {
      return !_.chain(this.$children).map(function (compoment) {
        return compoment.validate();
      }).some(function (flag) {
        return flag === false;
      }).value();
    },
    loadData: function loadData(obj) {
      var _this = this;

      _.each(obj, function (v, k) {
        _this.setValue(k, v);
      });
    },
    setValue: function setValue(field, value) {
      var childrenArr = this.$children,
          num = findIndex.call(this, field);
      _.isNumber(num) && childrenArr[num].setValue(value);
    },
    getValue: function getValue(field) {
      var childrenArr = this.$children,
          num = findIndex.call(this, field);
      return _.isNumber(num) && childrenArr[num].getValue();
    },

    getData: function getData() {
      var childrenArr = this.$children,
          dataObj = {};
      _.each(childrenArr, function (v) {
        dataObj = _Object$assign({}, dataObj, v.getData && v.getData());
      });
      return dataObj;
    }
  }

};


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui/default/form/src/form.js
// module id = 1486
// module chunks = 2